import {ga4TrackSimpleEvent} from "../../website/webpack/modules/analytics";

export function configureHelpWidget() {
    let helpWidgetType = document.getElementById('help-widget-type');
    let widgetHelpImg = document.querySelector('.widget-help img.secondary');
    if (widgetHelpImg) {
        widgetHelpImg.style.display = 'block';
        widgetHelpImg.src = widgetHelpImg.dataset.tawkSrc;
        $('.widget-help').click(function() {
            Tawk_API.toggle();
            let widget = document.querySelector('.widget-help');
            ga4TrackSimpleEvent({
                event: 'help_banner',
                method: 'personalization_service',
                content_type: widget ? widget.dataset.type : 'unknown'
            });
        });
    }
}
